var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFishFood(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36.844,
    height: 44.057,
    viewBox: "0 0 36.844 44.057",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.844,
    height: 44.057,
    fill: "#85d4b7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9,92.641q-7.257,0-14.514,0c-1.692,0-2.462-1.152-1.689-2.664a6.725,6.725,0,0,0,.324-5.293A30.03,30.03,0,0,1,7.1,66.6a1.309,1.309,0,0,1,1.428-1.1c2-.067,3.993-.239,5.983-.432.326-.032.879-.387.881-.6.005-.647-.579-.535-1.014-.5-2.023.168-4.045.363-6.069.524-1.457.116-2.231-.531-2.273-1.851-.047-1.486.636-2.173,2.172-2.171q14.246.011,28.492.035c.607,0,1.509-.256,1.555.718.048,1.02-.885.854-1.531.909q-9.328.783-18.659,1.541a1.254,1.254,0,0,0-.527.065,6.253,6.253,0,0,0-.72.611c.277.16.555.455.832.455.893,0,1.787-.1,2.679-.179q8.078-.673,16.154-1.352c.46-.039.857-.076,1.082.5,1.581,4.021,2.942,8.093,2.854,12.487a25.408,25.408,0,0,1-1.711,8.747,5.279,5.279,0,0,0,.366,4.888c.869,1.465.127,2.689-1.563,2.69q-7.3,0-14.606,0v.048M7.312,75.123a31.294,31.294,0,0,0,1.422,9.826c.091.278.492.455.748.68.092-.327.335-.7.254-.975A30.709,30.709,0,0,1,8.659,72c.036-.282-.273-.609-.422-.916-.221.261-.6.5-.636.787-.165,1.27-.232,2.552-.289,3.256m.361-5.5.692.809a3.046,3.046,0,0,0,.673-.858c.061-.19-.244-.5-.384-.752l-.981.8",
    transform: "translate(-4.652 -49.643)",
    fill: "#004878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.311,14.346H19.587a4.105,4.105,0,0,1,2-3.309A2.459,2.459,0,0,0,22.93,8.9a3.429,3.429,0,0,1,.695-1.7c1.609-2.165,6.437-2.439,7.723.852a1.912,1.912,0,0,0,1.769,1.415A1.956,1.956,0,0,0,35.025,8.12c.522-1.126,2.833-1.241,3.964-.234a2.674,2.674,0,0,1,.414.467,4.663,4.663,0,0,0,3.79,2.03,4.213,4.213,0,0,1,4.118,3.964",
    transform: "translate(-16.076 -4.575)",
    fill: "#e6ba0b"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFishFood);
export default __webpack_public_path__ + "static/media/fishFood.b52c74303f78d6c0e56ce61c6856d802.svg";
export { ForwardRef as ReactComponent };